import React from 'react';
import { IoEyeSharp } from 'react-icons/io5';
import { Link } from 'react-router-dom';

const ListParcelCertificate = ({ parcelCertificates }) => {
  return (
    <div className="listParcelCert">
      <div className="listParcelCert__container container">
        <h2 className="listParcelCert__title">Liste des Certificats Parcellaires 3</h2>
        <div className="listParcelCert__cards">
          {parcelCertificates.map((item) => (
            <div className="listParcelCert__card" key={item.id}>
              <h2 className="listParcelCert__card__titl">Certificat Parcellaire</h2>
              <div className="listParcelCert__names">
                <div className="listParcelCert__names__str">Nom du Propriétaire : </div>
                <span className="listParcelCert__names__name">{item.parcelNamesOwner}</span>
              </div>
              <Link to={`/parcels/${item.id}`} className="listParcelCert__btn">
                <IoEyeSharp className="listParcelCert__btn__icon" />
                <div className="listParcelCert__btn__span">Ouvrir le Certificat</div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ListParcelCertificate;